import {NgModule} from '@angular/core';
import {WorkService} from './work.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [
        WorkService
    ]
})
export class WorkHistoryModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/history/work.module.ts